import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { getFeaturedSliderSettings } from 'core/config/slides';
import ProductCardHome from 'components/artectum/cards/product-card-home';
import QuickViewModal from 'components/artectum/modal/QuickViewModal';
import PlaceholderCard from 'components/artectum/cards/PlaceholderCard';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';
import { getData } from 'core/services/api';

const FeaturedItemV2 = ({ categoryId }) => {
    const [productsData, setProductsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 1024);

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const response = await getData(`${API_ENDPOINTS.PRODUCT_FROM_CATEGORIES}${categoryId}`);
                setProductsData(response.data.data);
            } catch (error) {
                console.error('Error fetching products:', error);
            } finally {
                setLoading(false);
            }
        };

        if (categoryId) {
            fetchProducts();
        }
    }, [categoryId]);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth > 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleQuickView = (product) => {
        setSelectedProduct(product);
        setShowModal(true);
    };

    const handleModalClose = () => setShowModal(false);

    return (
        <div>
            <div className="ltn__product-slider-area ltn__product-gutter pt-90 pb-30">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title-area ltn__section-title-2--- text-center mb-3">
                                <h1 className="section-title mb-0">Productos Destacados</h1>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <div className="row d-flex justify-content-center">
                            {[...Array(4)].map((_, index) => (
                                <div className="col-md-3 col-sm-6 col-6" key={index}>
                                    <PlaceholderCard />
                                </div>
                            ))}
                        </div>
                    ) : (
                        isLargeScreen && productsData?.length <= 4 ? (
                            <div className="row d-flex justify-content-center">
                                {productsData?.map((item, index) => (
                                    <div className="col-md-3 col-sm-6 col-6" key={index}>
                                        <ProductCardHome  item={item} onQuickView={handleQuickView} loading={loading} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Slider {...getFeaturedSliderSettings(productsData?.length)}>
                                {productsData?.map((item, index) => (
                                    <div key={index}>
                                        <div className="col-md-12 col-10 m-auto p-0 m-md-0" key={index}>
                                            <ProductCardHome item={item} onQuickView={handleQuickView} loading={loading} />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        )
                    )}
                </div>
                {selectedProduct && (
                    <QuickViewModal
                        show={showModal}
                        product={selectedProduct}
                        onHide={handleModalClose}
                        item={selectedProduct}
                    />
                )}
            </div>
        </div>
    );
};

export default FeaturedItemV2;